var exports = {
  "Lm": "xcc377c0b--6ac90c--holder",
  "Qs": "xcc377c0b--6ac90c--content",
  "TL": "xcc377c0b--6ac90c--icon-holder",
  "wx": "xcc377c0b--6ac90c--header",
};

module.exports = exports;
